import { CabinGradeType, TripSearchResultTag } from "@cruisen/contract"
import { cruiseSortingKeys, FilterRange, SelectedFilters } from "@cruisen/react-shared"
import { makeAutoObservable } from "mobx"

type CruiseListModals = "sorting" | "filtering" | "savePreferences"

export class CruiseListStore {
  priceFilters: FilterRange
  shipYearFilters: FilterRange
  selectedShips: string[]
  selectedCruiseLines: string[]
  selectedDurations: string[]
  selectedOriginPorts: string[]
  selectedDestinationPorts: string[]
  selectedTags: TripSearchResultTag[]
  selectedAgentLikedCruise: boolean
  selectedStartDate: string | null
  selectedEndDate: string | null
  selectedCabinGradeTypes: CabinGradeType[]

  activeModal: null | CruiseListModals
  sortingOption: string
  isDragging: boolean
  isDatePickerOpen: boolean

  constructor() {
    this.shipYearFilters = { low: null, high: null }
    this.priceFilters = { low: null, high: null }
    this.selectedShips = []
    this.selectedCruiseLines = []
    this.selectedDurations = []
    this.selectedOriginPorts = []
    this.selectedDestinationPorts = []
    this.selectedTags = []
    this.selectedAgentLikedCruise = false
    this.selectedStartDate = null
    this.selectedEndDate = null
    this.selectedCabinGradeTypes = []

    this.activeModal = null
    this.sortingOption = cruiseSortingKeys.mostLikes
    this.isDragging = false
    this.isDatePickerOpen = false

    makeAutoObservable(this)
  }

  setIsDragging(value: boolean) {
    this.isDragging = value
  }

  setIsDatePickerOpen(value: boolean) {
    this.isDatePickerOpen = value
  }

  setActiveModal(modal: null | CruiseListModals) {
    this.activeModal = modal
  }

  toggleActiveModal(modal: null | CruiseListModals) {
    this.activeModal = this.activeModal === null ? modal : null
  }

  setSortingOption(option: string) {
    this.sortingOption = option
  }

  resetFilters() {
    this.shipYearFilters = { low: null, high: null }
    this.priceFilters = { low: null, high: null }
    this.selectedShips = []
    this.selectedCruiseLines = []
    this.selectedDurations = []
    this.selectedOriginPorts = []
    this.selectedDestinationPorts = []
    this.selectedTags = []
    this.selectedAgentLikedCruise = false
    this.selectedStartDate = null
    this.selectedEndDate = null
    this.selectedCabinGradeTypes = []
  }

  handleFilters(values: SelectedFilters) {
    if (!values) return

    this.priceFilters = values.priceFilters
    this.selectedShips = values.selectedShips
    this.selectedCruiseLines = values.selectedCruiseLines
    this.shipYearFilters = values.shipYearFilters
    this.selectedDurations = values.selectedDurations
    this.selectedOriginPorts = values.selectedOriginPorts
    this.selectedDestinationPorts = values.selectedDestinationPorts
    this.selectedTags = values.selectedTags
    this.selectedAgentLikedCruise = values.selectedAgentLikedCruise
    this.selectedStartDate = values.selectedStartDate
    this.selectedEndDate = values.selectedEndDate
    this.selectedCabinGradeTypes = values.selectedCabinGradeTypes || []
  }

  get selectedFilters() {
    if (
      this.shipYearFilters.low === null &&
      this.shipYearFilters.high === null &&
      this.priceFilters.low === null &&
      this.priceFilters.high === null &&
      this.selectedShips.length === 0 &&
      this.selectedCruiseLines.length === 0 &&
      this.selectedDurations.length === 0 &&
      this.selectedOriginPorts.length === 0 &&
      this.selectedDestinationPorts.length === 0 &&
      !this.selectedTags?.length &&
      !this.selectedAgentLikedCruise &&
      this.selectedStartDate === null &&
      this.selectedEndDate === null &&
      this.selectedCabinGradeTypes.length === 0
    ) {
      return null
    }

    return {
      priceFilters: this.priceFilters,
      selectedShips: this.selectedShips,
      selectedCruiseLines: this.selectedCruiseLines,
      shipYearFilters: this.shipYearFilters,
      selectedDurations: this.selectedDurations,
      selectedOriginPorts: this.selectedOriginPorts,
      selectedDestinationPorts: this.selectedDestinationPorts,
      selectedTags: this.selectedTags,
      selectedAgentLikedCruise: this.selectedAgentLikedCruise,
      selectedStartDate: this.selectedStartDate,
      selectedEndDate: this.selectedEndDate,
      selectedCabinGradeTypes: this.selectedCabinGradeTypes,
    }
  }
}
